'use es6';

import { fetchTroubleshootTimesRequest } from '../../api/troubleshootAPI';
import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import getIn from 'transmute/getIn';
export var troubleshootActionTypes = {
  REQUEST_TROUBLESHOOT_TIMES: 'REQUEST_TROUBLESHOOT_TIMES',
  RECEIVE_TROUBLESHOOT_TIMES: 'RECEIVE_TROUBLESHOOT_TIMES',
  REQUEST_TROUBLESHOOT_TIMES_REJECTED: 'REQUEST_TROUBLESHOOT_TIMES_REJECTED'
};
var REQUEST_TROUBLESHOOT_TIMES = troubleshootActionTypes.REQUEST_TROUBLESHOOT_TIMES,
    RECEIVE_TROUBLESHOOT_TIMES = troubleshootActionTypes.RECEIVE_TROUBLESHOOT_TIMES,
    REQUEST_TROUBLESHOOT_TIMES_REJECTED = troubleshootActionTypes.REQUEST_TROUBLESHOOT_TIMES_REJECTED;
export var requestTroubleshootTimes = function requestTroubleshootTimes() {
  return {
    type: REQUEST_TROUBLESHOOT_TIMES
  };
};
export var receiveTroubleshootTimes = function receiveTroubleshootTimes(data) {
  return {
    type: RECEIVE_TROUBLESHOOT_TIMES,
    data: data
  };
};
export var requestTroubleshootTimesRejected = function requestTroubleshootTimesRejected(err) {
  return {
    type: REQUEST_TROUBLESHOOT_TIMES_REJECTED,
    err: err
  };
};
export var fetchTroubleshootTimes = function fetchTroubleshootTimes() {
  return function (dispatch, getState) {
    var slug = getState().userSlug;
    var portalId = getIn(['bookInfo', 'portalId'])(getState());
    dispatch(requestTroubleshootTimes());
    return fetchTroubleshootTimesRequest(noPortalApiClient, slug, portalId).then(function (response) {
      return dispatch(receiveTroubleshootTimes(response));
    }).catch(function (err) {
      return dispatch(requestTroubleshootTimesRejected(err));
    });
  };
};